import { Field, TextInput, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";

export default function EditFooter({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setLink = (i, key, v) => {
    const links = [...(value.links || [])];
    links[i] = { ...links[i], [key]: v };
    set("links", links);
  };
  const addLink = () => set("links", [...(value.links || []), { label: "Novo link", url: "#" }]);
  const removeLink = (i) => set("links", (value.links || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Footer / Rodapé">
      <div className="space-y-5">
        <Field label="Tagline (frase curta)"><TextInput value={value.tagline} onChange={(v) => set("tagline", v)} testId="footer-tagline-input" /></Field>
        <Field label="Texto de copyright"><TextInput value={value.copyright} onChange={(v) => set("copyright", v)} testId="footer-copyright-input" /></Field>
        <Field label="E-mail de contato"><TextInput value={value.email} onChange={(v) => set("email", v)} testId="footer-email-input" /></Field>
        <Field label="Instagram"><TextInput value={value.instagram} onChange={(v) => set("instagram", v)} testId="footer-instagram-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Links</span>
            <ListAddBtn onClick={addLink} label="Adicionar link" testId="footer-add-link" />
          </div>
          <div className="space-y-3">
            {(value.links || []).map((l, i) => (
              <div key={i} data-testid={`footer-link-row-${i}`} className="grid sm:grid-cols-12 gap-3 items-center">
                <div className="sm:col-span-5"><Field label="Texto"><TextInput value={l.label} onChange={(v) => setLink(i, "label", v)} testId={`footer-link-label-${i}`} /></Field></div>
                <div className="sm:col-span-6"><Field label="URL"><TextInput value={l.url} onChange={(v) => setLink(i, "url", v)} testId={`footer-link-url-${i}`} /></Field></div>
                <div className="sm:col-span-1 flex justify-end pt-6"><ListRemoveBtn onClick={() => removeLink(i)} testId={`footer-link-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
